// @flow


// import webb from '../../../../interface_config';
// import UIEvents from '../../../../service/UI/UIEvents';
import { MiddlewareRegistry } from '../redux';

import { SET_ATTENDANCE_API } from './actionTypes';
import { sendUserAttendance } from './actions';


// import {
//     setGenericIFrameVisibilityState,
//     setGenericIFrameUrl
// } from '../../genericiframe/actions';
// import { CONFERENCE_JOINED, getCurrentConference } from '../conference';
// import { setActiveModalId } from '../modal';
// import { isLocalParticipantModerator } from '../participants';


// // import { SHARE_GENERICIFRAME_VIEW_ID } from './constants';


// declare var APP: Object;

// const GENERICIFRAME_COMMAND = 'genericiframe';

/**
 * Middleware that captures actions related to collaborative document editing
 * and notifies components not hooked into redux.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
// eslint-disable-next-line no-unused-vars
MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    switch (action.type) {

    case SET_ATTENDANCE_API:
        // eslint-disable-next-line no-case-declarations
        const isLogout = action.isLogout;

        return sendUserAttendance({ getState,
            isLogout });

    }

    return next(action);
});


